<template>
  <v-layout row wrap justify-center mt-3>
    <v-flex xs12 sm2 md4 lg2>
      <ul class="unstyled-list text-xs-center">
        <li v-for="(item, index) in numeroBotones" class="list-bots-vert">
          <button 
          :id="'bots-num-vert'+index" 
          @click="showCont(index)" 
          class="bots-colors-menu" 
          :aria-label="'Botón ' + (index+1) + ' ' + (botones[index].visto?'visto':'no visto')" 
          :class="botsColorsClass(index)">
            {{index+1}}
          </button>
        </li>
      </ul>
    </v-flex>
    <v-flex xs12 sm8 md6 lg6 class="aligner">
      <div id="banner-slide-contain" tabindex="0" class="textos">
        <slot v-if="index + 1 === contenidoActual" v-for="(item, index) in numeroBotones" :name="'cont'+index"></slot>
        <button v-if="!finContenidos && (contenidoActual > 0)" @click="backMenu()" aria-label="Volver a la lista anterior"></button>
      </div>
    </v-flex>
  </v-layout>
</template>
<script>
export default {
  props: {
    numeroBotones: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      contenidoActual: 0,
      finContenidos: false,
      currentBot: 0,
      botColors: [
        "botnaranja",
        "botazul",
        "botrojo",
        "botverde",
        "botnaranja",
        "botazul",
        "botrojo",
        "botverde"
      ]
    };
  },
  methods: {
    showCont(event) {
      this.contenidoActual = event + 1;
      this.botones[event].visto = true;
      document.getElementById("banner-slide-contain").focus();
      var showNext = this.botones.every(elem => {
        return elem.visto === true;
      });
      if (showNext) {
        this.$store.commit("nextShow", true);
      }
      this.finContenidos = showNext;
    },
    backMenu() {
      document.getElementById("bots-num-vert" + this.contenidoActual).focus();
    },
    botsColorsClass(event) {
      var claseUno = event + 1 === this.contenidoActual ? "active" : "";
      var claseDos = this.botColors[event];
      var claseTres = this.botones[event].visto ? "visto" : "";
      return claseUno + " " + claseDos + " " + claseTres;
    }
  },
  computed: {
    botones() {
      var arrayBots = [];
      for (let index = 0; index < this.numeroBotones; index++) {
        arrayBots.push({
          visto: false
        });
      }
      return arrayBots;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../sass/helpers/variables";
@import "../../sass/helpers/mixins";
.list-bots-vert {
  display: inline-block;
}
.bots-colors-menu {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  margin: 5px;
  font-size: 30px;
  font-weight: bold;
  text-align: center;
  background: #eee;
  position: relative;
  @include shadow(0 0 5px black);
  &.botnaranja {
    color: $primary-orange;
    &.active {
      color: white;
      background-color: $primary-orange;
    }
  }
  &.botazul {
    color: $primary-blue;
    &.active {
      color: white;
      background-color: $primary-blue;
    }
  }
  &.botrojo {
    color: $primary-red;
    &.active {
      color: white;
      background-color: $primary-red;
    }
  }
  &.botverde {
    color: $primary-green;
    &.active {
      color: white;
      background-color: $primary-green;
    }
  }
  &.visto {
    &:after {
      content: "";
      background-image: url('../../assets/logos-icons/ok-bullet.png');
      background-size: contain;
      position: absolute;
      width: 20px;
      height: 20px;
      right: -10px;
      top: 0;
    }
  }
}

.textos {
  &:focus {
    outline: none;
  }
}

@media (min-width: 600px) {
  .list-bots-vert {
    display: block;
  }
}
</style>




// WEBPACK FOOTER //
// BotsNumberVert.vue?5b9c7391